// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-andy-src-templates-note-js": () => import("./../../../node_modules/gatsby-theme-andy/src/templates/note.js" /* webpackChunkName: "component---node-modules-gatsby-theme-andy-src-templates-note-js" */)
}

